import React, { useState } from 'react';
import * as api from '../services/api';
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import add from '../../assets/icons/add.svg';
import InsertBar from '../../components/InsertBar';
import deleteBin from '../../assets/icons/delete.svg';
import CustomizedModal from '../../components/modal/CustomizedModal';
import PrevAndNextBtn from '../../components/PrevAndNextBtn';
import { Box, Button, Input, Checkbox } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

function NewsEdit() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(location.state.detail || {});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [new_detail, setNewDetail] = useState(detail.new_detail);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showDeleteImageModal, setShowDeleteImageModal] = useState(false);
  const [index, setIndex] = useState(null);

  const user = useSelector(getUser);

  const handlePrevious = () => {
    navigate('/newsManager');
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    setShowUpdateModal(true);
  };
  
  const confirmedUpdate = async () => {
    detail.updated_date = new Date().toISOString();
    detail.updated_user = user?.uid;
    detail.new_detail = new_detail;

    setLoading(true);
    const res = await api.updateNews(detail);
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        handlePrevious() //navigate
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };
  
  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === detail.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? detail.images.length - 1 : prevIndex - 1
    );
  };

  const handleCheckboxChangeBanner = (value) => {
    setDetail((prevDetail) => ({
      ...prevDetail,
      banner_status: value ? "Y" : "N",
    }));
  };

  const handleCheckboxChangeFavorite = (value) => {
    setDetail((prevDetail) => ({
      ...prevDetail,
      favorite_status: value ? "Y" : "N",
    }));
  };

  const uploadImage = async (file) => {
    const res = await api.uploadFile(file);
    return res.data.data.url;
  }

  // Handle adding new image
  const handleAddImages = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      try {
        setLoading(true);
        const uploadedImageUrls = [];
        for (const file of files) {
          const uploadedImageUrl = await uploadImage(file);
          uploadedImageUrls.push(uploadedImageUrl);
        }
        setDetail((prevDetail) => ({
          ...prevDetail,
          images: [...(prevDetail.images || []), ...uploadedImageUrls],
        }));
      } catch (error) {
        handleError("อัพโหลดรูปไม่สำเร็จ ลองใหม่อีกครั้ง");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDeleteImage = () => {
      setDetail((prevDetail) => ({
        ...prevDetail,
        images: prevDetail.images.filter((_, i) => i !== index),
      }));
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? 0 : prevIndex - 1
      );
      setIndex(null);
      setShowDeleteImageModal(false);
  };

  return (
    <>
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะแก้ไขข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      {/* Delete Image */}
      {showDeleteImageModal && (
        <CustomizedModal
        onClose={() => setShowDeleteImageModal(false)} 
        apiCall={handleDeleteImage}
        confirmMessage={"ยืนยันการลบรูปนี้"}
        confirmButtonText={"ตกลง"}
        />
      )}

      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการข่าวสาร
      </Box>
      <Box className={styles.head1Text}>แก้ไขข่าวสารสุขภาพ</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        {/* Title Section */}
        <Box className={styles.head2Text}>ชื่อหัวเรื่อง</Box>
        <InsertBar
          currentValue={detail.new_title}
          setNewValue={(newTitle) => setDetail({ ...detail, new_title: newTitle })}
          placeholder="ชื่อหัวเรื่อง"
        />

        {/* Images Section */}
        <Box className={styles.head2Text} sx={{ marginTop: 1, display: 'flex', alignItems: 'center' }}>
          รูปภาพประกอบ
          <img
            src={add}
            alt="Add"
            onClick={() => document.getElementById('file-input').click()}
            className={styles.modifyIcon}
            style={{ marginLeft: '8px' }}
          />
          {/* File input hidden, triggered by the Add icon */}
          <Input
            id="file-input"
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={handleAddImages}
            sx={{ display: 'none' }}
          />
        </Box>

        {/* Display images */}
        <Box
          sx={{
            marginBottom: 2,
            textAlign: 'center',
            border: '1.4px solid #478F96',
            borderRadius: 2,
            height: '300px',
            padding: 3,
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {detail.images && detail.images.length > 0 ? (
            <>
              {/* Delete Image Button */}
              <img
                src={deleteBin}
                alt="Delete"
                onClick={() => {
                  setIndex(currentIndex); 
                  setShowDeleteImageModal(true); 
                }}
                className={styles.modifyIcon}
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  zIndex: 1,
                }}
              />
              <Box sx={{ position: 'relative', height: '100%' }}>
                {/* Current Image */}
                <img
                  src={detail.images[currentIndex]}
                  alt={`Slide ${currentIndex + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </>
          ) : (
            <p>ไม่มีรูปภาพ</p>
          )}
        </Box>

        {/* Prev and Next Buttons */}
        <Box>
          {detail.images && detail.images.length > 0 ? (
            <PrevAndNextBtn
              handlePrevious={handlePrevImage}
              handleNext={handleNextImage}
              currentPage={currentIndex + 1}
              totalPage={detail.images.length}
              style={{
                position: 'absolute',
                bottom: '16px',
                right: '16px',
              }}
            />
          ) : null}
        </Box>

        {/* Checkboxes */}
        <Box className={styles.bodyText} sx={{ textAlign: 'center', marginTop: -1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Checkbox
              checked={detail.banner_status === "Y"}
              onChange={(e) => handleCheckboxChangeBanner(e.target.checked)}
              inputProps={{ 'aria-label': 'Checkbox for banner' }}
            />
            <p style={{ fontSize: '12px', marginLeft: -15 }}>ปักไว้ในแบนเนอร์</p>
            <Checkbox
              className={styles.bodyText2}
              checked={detail.favorite_status === "Y"}
              onChange={(e) => handleCheckboxChangeFavorite(e.target.checked)}
              inputProps={{ 'aria-label': 'Checkbox for favorite' }}
            />
            <p style={{ fontSize: '12px', marginLeft: -15 }}>ปักไว้ในบทความแนะนำ</p>
          </Box>
        </Box>

        {/* Tags Section */}
        <Box className={styles.head2Text} sx={{ marginTop: 1 }}>คำสำคัญ / แท็ก</Box>
        <InsertBar
          currentValue={detail.remark}
          setNewValue={(newRemark) => setDetail({ ...detail, remark: newRemark })}
          placeholder="คำสำคัญ / แท็ก"
        />

        {/* Rich Text Editor Section */}
        <ReactQuill
          theme="snow"
          value={new_detail}
          onChange={setNewDetail}
          placeholder="ใส่ข้อความที่นี่"
          modules={{
            toolbar: [
              [{ color: [] }, { background: [] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ size: ['small', false, 'large', 'huge'] }],
              // [{ align: [] }], 
              [{ header: [1, 2, 3, 4, 5, false] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              ['blockquote'],
              ['link', 'image', 'video'],
            ],
          }}
          formats={[
            'header',
            'size',
            'bold',
            'italic',
            'underline',
            'strike',
            'color',
            'background',
            'list',
            'bullet',
            // 'align',
            'blockquote',
            'link',
            'image',
            'video',
          ]}
        />
      </Box>
      {/* Save Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2, marginRight: 4.3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default NewsEdit;
